// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app[data-v-bd74b2e8]{width:100%;height:100%;overflow:auto;position:relative}.sidebar[data-v-bd74b2e8]{background:#171725;height:100% !important}.dashboard-background-color[data-v-bd74b2e8]{background:#f7f7f7}.logout-btn[data-v-bd74b2e8]{border-color:red}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
